"use client";

import Image, { StaticImageData } from "next/image";
import Link from "next/link";


interface FeaturedBlogPost {
  cover_picture: string;
  title: string;
  summary: string;
  authorImage: StaticImageData;
  authorName: string;
  meta: string;
  read_time: string;
  created: string;
  slug: string;
}

export default function FeaturedBlogPost(
  {
    cover_picture,
    title,
    summary,
    created,
    read_time,
    slug,
  }: FeaturedBlogPost
) {
  return (
    <div className="mt-10">
      <Link href={`/blog/${slug}`} className="text-black rounded-b-xl shadow-xl">
        <div className="relative min-h-[240px] rounded-t-xl">
          <Image
            src={cover_picture}
            alt="cover picture"
            fill
            sizes="(max-width: 768px) 100vw"
            className="rounded-t-xl object-cover"
           placeholder="blur"
           blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mPUM9CrBwACLQENP3mOdwAAAABJRU5ErkJggg=="
          />
        </div>
        <div className="p-6">
          <h3 className="text-xl font-bold line-clamp-3">
              {title}
          </h3>
          <article className="mt-4 text-ginger-gray-100 line-clamp-4">{summary}</article>
          <div className="flex flex-col text-sm mt-2">
            <span className="text-ginger-gray-100">
            {created}
            {' • '}
            {read_time}
            </span>
          </div>
        </div>
    </Link>
    </div>
    );
}

